import { Location, Link } from '../traveldoc';

export class DisplayLinks {
    location: Location;
    healthHTML: string;
    customsHTML: string;
    otherResources: string;
}
